export default __webpack_public_path__ + "static/media/position-marker.2930ef65.svg";